import { FilteringDataMapOptions } from '../../interfaces/options';

export const DefaultFilteringDataMapOptions: FilteringDataMapOptions<any> = {
	bypass: () => false,
	prefilter: []
};
